import getBibibopContent from 'pared/aiBlackbox/bibibop'
import getExpoContent from 'pared/aiBlackbox/expo'
import getFwWingstopContent from 'pared/aiBlackbox/fw_wingstop'
import getMwbContent from 'pared/aiBlackbox/mwb'

import AiBlackboxContentTester from './AiBlackboxContentTester'
import { IAiBlackboxProps } from './type'

export default function getAiBlackboxContent(
  contentPartNames: string[],
): (React.FC<IAiBlackboxProps> | null)[] {
  return contentPartNames.map((name) => {
    const expoContent = getExpoContent(name)
    const mwbContent = getMwbContent(name)
    const fwWingstopContent = getFwWingstopContent(name)
    const bibibopContent = getBibibopContent(name)

    if (expoContent) {
      return expoContent
    }

    if (mwbContent) {
      return mwbContent
    }

    if (fwWingstopContent) {
      return fwWingstopContent
    }

    if (bibibopContent) {
      return bibibopContent
    }

    switch (name) {
      case 'tester':
        return AiBlackboxContentTester
      default:
        return null
    }
  })
}
